export enum BalanceSheetReportTabs {
  RENTAL_LOANS = 'RENTAL_LOANS',
  BRIDGE_LOANS = 'BRIDGE_LOANS',
  GROUND_UP_LOANS = 'GROUND_UP_LOANS',
};

export const balanceSheetReportTabLabels: Record<BalanceSheetReportTabs, string> = {
  [BalanceSheetReportTabs.RENTAL_LOANS]: 'Rental',
  [BalanceSheetReportTabs.BRIDGE_LOANS]: 'Bridge',
  [BalanceSheetReportTabs.GROUND_UP_LOANS]: 'Ground Up',
};
